/* Shared, deterministic season aliases and full-scan recommendation ranking. */
(function (root) {
  'use strict';
  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_]+/g, '-').replace(/-+/g, '-');
  }
  var aliases = {
    'aw': 'all-weather', 'all-weather': 'all-weather', 'allweather': 'all-weather',
    'all-weathers': 'all-weather', 'all-season': 'all-season', 'allseason': 'all-season',
    'all-seasons': 'all-season', '4-season': 'all-season', 'summer': 'all-season',
    'winter-studless': 'winter-studless', 'winter-non-studded': 'winter-studless',
    'winter-studdable': 'winter-studdable'
  };
  function season(type, tags) {
    var typed = aliases[normalize(type)];
    if (typed) return typed;
    var values = (tags || []).map(function (tag) { return aliases[normalize(tag)]; }).filter(Boolean);
    // AW must never disappear behind a general "4-season" merchandising tag.
    return values.includes('all-weather') ? 'all-weather' : values[0] || null;
  }
  function text(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function rebate(record, rules, today) {
    // Ignore the shop's appended season label when matching a model named
    // "All Season"; otherwise every Firestone summer tire would qualify.
    var modelTitle = String(record.title || '').replace(/\s*[-–—]\s*(?:all[- ]season|all[- ]weather|winter[- ]studless|winter[- ]studdable)\s+tire.*$/i, '');
    var title = text(modelTitle), brand = text(record.vendor);
    var hits = (rules.programs || []).filter(function (p) {
      return today >= p.start && today <= p.end &&
        (brand === text(p.brand) || title.includes(text(p.brand))) &&
        !(p.exclude || []).some(function (model) { return title.includes(text(model)); }) &&
        (p.models === '*' || p.models.some(function (model) { return title.includes(text(model)); }));
    });
    // Never subtract an "up to" tag or invent an amount for an unlisted model.
    return hits.reduce(function (amount, hit) { return Math.max(amount, hit.cents); }, 0);
  }
  function stock(record) { return record.stock || {}; }
  function stockVerified(data) {
    return data.tntDestinationState !== 'failed' &&
      (data.tntDestinationExempt === 'true' || data.tntStockKnown === 'true');
  }
  function eligible(record) {
    var s = stock(record);
    return record.tire && Number.isSafeInteger(record.price) && record.price > 0 &&
      s.known === true && s.state === 'ready' && !s.exempt && !s.preorder && s.available >= 4;
  }
  function freeEligible(record, province) {
    var tags = (record.tags || []).map(function (tag) { return String(tag).trim().toLowerCase(); });
    return province === 'NL' && eligible(record) && stock(record).bucket === 'nl' &&
      Number.isSafeInteger(stock(record).mountPearlAvailable) && stock(record).mountPearlAvailable >= 4 &&
      tags.includes('free shipping') && tags.includes(atob('bGFjaWUtbmwtc3RvY2tlZA==')) &&
      (tags.includes(atob('X3N1cDpsYWNpZQ==')) || tags.includes(atob('bGEgY2ll')));
  }
  function choose(records, options) {
    var rules = options.rules || { programs: [], premiumBrands: [] };
    var pool = records.filter(eligible);
    var compare = function (a, b) { return a.price - b.price || a.handle.localeCompare(b.handle); };
    var value = pool.slice().sort(compare)[0] || null;
    var premium = pool.filter(function (r) {
      var title = text(r.title), vendor = text(r.vendor);
      return (rules.premiumBrands || []).some(function (brand) {
        return vendor === text(brand) || title.includes(text(brand));
      });
    }).sort(function (a, b) {
      return (a.price * 4 - rebate(a, rules, options.today)) -
        (b.price * 4 - rebate(b, rules, options.today)) || compare(a, b);
    })[0] || null;
    var free = pool.filter(function (r) { return freeEligible(r, options.province); }).sort(compare)[0] || null;
    return { premium: premium, value: value, free: free };
  }
  function restart(state) {
    state.next = state.initialUrl;
    state.expected = null;
    state.pool = [];
    state.candidates.clear(); state.seen.clear(); state.visited.clear();
    state.complete = false; state.error = false; state.renderKey = null;
    return state;
  }
  var api = { season: season, rebate: rebate, stockVerified: stockVerified, eligible: eligible, freeEligible: freeEligible, choose: choose, restart: restart };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.TntTirePicks = api;
})(typeof window === 'undefined' ? null : window);

/* Full-search counts and working chips share one sequential live-stock scan.
   No loaded-page count is ever presented as a complete result total. */
(function (root) {
  'use strict';
  function words(value) {
    return String(value || '').toLowerCase().normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stripSeasonText(query) {
    return String(query || '').replace(/(^|[\s("'])(winter[\s_-]*(?:non[\s_-]*studded|studless)|winter[\s_-]*(?:studdable|studded)|all[\s_-]*weathers?|all[\s_-]*seasons?|winter|summer)(?=$|[\s)"'])/gi, '$1 ');
  }
  function seasonFromQuery(query) {
    query = String(query || '');
    if (/\b(?:OR|NOT)\b/i.test(query)) return null;
    query = query.replace(/\b[a-z_]+:\s*(?:"[^"]*"|'[^']*'|[^\s()]+)/gi, ' ');
    if (/\bwinter[\s_-]*(?:non[\s_-]*studded|studless)\b/i.test(query)) return 'winter-studless';
    if (/\bwinter[\s_-]*(?:studdable|studded)\b/i.test(query)) return 'winter-studdable';
    if (/\ball[\s_-]*weathers?\b/i.test(query)) return 'all-weather';
    if (/\ball[\s_-]*seasons?\b|\bsummer\b/i.test(query)) return 'all-season';
    return /\bwinter\b/i.test(query) ? 'winter' : null;
  }
  function seasonMatchesRecord(record, requested) {
    if (!requested) return true;
    var actual = root && root.TntTirePicks && root.TntTirePicks.season(record.type, record.tags || []);
    if (!actual) actual = seasonFromQuery(record.title);
    return requested === 'winter' ? actual === 'winter' || /^winter-/.test(actual || '') : actual === requested;
  }
  function plainQuery(query) {
    query = String(query || '');
    query = query.replace(/\(\s*(?:tag:)?["']?province:[a-z]+["']?\s+OR\s+(?:tag:)?["']?province:ALL["']?\s*\)/gi, ' ');
    if (/\b(?:OR|NOT)\b/i.test(query)) return null;
    query = query.replace(/\b[a-z_]+:\s*(?:"[^"]*"|'[^']*'|[^\s()]+)/gi, ' ');
    query = query.replace(/(?:^|[^a-z0-9])(?:LT|ST|P)?\d{3}\s*\/\s*\d{2,3}\s*[RZ-]\s*\d{2,3}(?:\.\d+)?(?=$|[^a-z0-9])/gi, ' ');
    query = query.replace(/(?:^|[^a-z0-9])(?:LT|ST)?\d{2,3}(?:\.\d{1,2})?\s*x\s*\d{1,2}(?:\.\d{1,2})?\s*r\s*\d{2,3}(?=$|[^a-z0-9])/gi, ' ');
    query = query.replace(/(^|[\s(])\d{6,8}(?=$|[\s)])/g, ' ');
    query = stripSeasonText(query).replace(/\bAND\b/gi, ' ');
    return words(query);
  }
  function vendorForQuery(query, vendors) {
    var plain = plainQuery(query);
    if (!plain) return null;
    var matches = Array.from(new Set(vendors)).filter(function (vendor) {
      var name = words(vendor);
      return name && (' ' + plain + ' ').indexOf(' ' + name + ' ') !== -1;
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function sizeCodes(value, bare) {
    value = String(value || '').toLowerCase();
    var codes = [], match;
    var metric = /(?:^|[^a-z0-9])(?:lt|st|p)?(\d{3})\s*\/\s*(\d{2,3})\s*[rz-]\s*(\d{2,3}(?:\.\d+)?)(?=$|[^a-z0-9])/g;
    while ((match = metric.exec(value))) codes.push(String(Number(match[1])) + String(Number(match[2])) + String(Number(match[3])).replace('.', ''));
    var flotation = /(?:^|[^a-z0-9])(?:lt|st)?(\d{2,3}(?:\.\d{1,2})?)\s*x\s*(\d{1,2}(?:\.\d{1,2})?)\s*r\s*(\d{2,3})(?=$|[^a-z0-9])/g;
    while ((match = flotation.exec(value))) {
      codes.push(match[1].replace('.', '') + match[2].replace('.', '') + match[3]);
      codes.push('f:' + Number(match[1]) + ':' + Number(match[2]) + ':' + Number(match[3]));
    }
    if (bare) {
      var numeric = /(?:^|[\s(:])(\d{6,8})(?=$|[\s)])/g;
      while ((match = numeric.exec(value))) codes.push(match[1]);
    }
    return codes;
  }
  function sizeMatchesTitle(title, query) {
    var wanted = sizeCodes(query, true);
    if (!wanted.length) return !/\d{2,4}\s*\/\s*\d|\d{2,3}(?:\.\d+)?\s*x\s*\d/i.test(String(query || ''));
    var actual = sizeCodes(title, false);
    return wanted.some(function (code) { return actual.includes(code); });
  }
  function candidateText(query) {
    // For an unstructured size+model/unknown-brand query, search the text
    // first and enforce size locally. Otherwise a nonexistent word still
    // returns every tire in the size and needlessly scans the whole catalog.
    if (/[a-z_]+:/i.test(query) || !sizeCodes(query, true).length) return null;
    return plainQuery(query) || null;
  }
  function numericSizeCodes(query) {
    return Array.from(new Set(sizeCodes(query, true).filter(function (code) { return /^\d{6,8}$/.test(code); })));
  }
  function matchesSizeTags(record, query) {
    var codes = numericSizeCodes(query);
    if (!codes.length) return true;
    var tags = (record.tags || []).map(function (tag) { return String(tag).trim().replace(/^tag:/i, ''); });
    return codes.some(function (code) { return tags.includes(code); });
  }
  function textMatches(record, query) {
    // Candidate search is fuzzy. Ordinary query terms must all match, but
    // advanced OR/NOT expressions retain Shopify's native interpretation.
    var plain = plainQuery(query);
    if (plain === null) return true;
    var terms = plain.split(' ').filter(Boolean);
    var haystack = words([record.title, record.vendor].concat(record.tags || []).join(' '));
    var tokens = haystack.split(' ');
    return terms.every(function (term, index) {
      return tokens.some(function (token) {
        return token === term || (index === terms.length - 1 && token.indexOf(term) === 0);
      });
    });
  }
  var api = { textMatches: textMatches, vendorForQuery: vendorForQuery, sizeMatchesTitle: sizeMatchesTitle, candidateText: candidateText,
    hasSize: function (query) { return sizeCodes(query, true).length > 0; },
    numericSizeCodes: numericSizeCodes, matchesSizeTags: matchesSizeTags,
    stripSeasonText: stripSeasonText, seasonFromQuery: seasonFromQuery, seasonMatchesRecord: seasonMatchesRecord };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.TntSearchQuery = api;
})(typeof window === 'undefined' ? null : window);
(function () {
  'use strict';
  if (!/\/search\/?$/.test(location.pathname)) return;
  // Prevent a second integrity controller from erasing this verified grid.
  window.__tntQuickResultsOwnGrid = true;
  var active, timer, cache = new Map(), vendorCache = new Map(), controls;
  var titleSuffix = (document.title.match(/\s[\u2013\u2014]\s*(.+)$/) || [])[1] || '';
  var seasons = ['all-season', 'all-weather', 'winter-studless', 'winter-studdable'];
  var labels = ['All-season', 'All-weather', 'Winter — non-studded', 'Winter — studdable'];
  var toggles = [
    ['stock', '4+ in stock'], ['nl', 'Ships from Newfoundland'],
    ['direct', 'Direct import tires'], ['lt', 'Light truck (LT)'],
    ['lrc', 'Load range C (6-ply)'], ['lrd', 'Load range D (8-ply)'],
    ['lre', 'Load range E (10-ply)'], ['lrf', 'Load range F (12-ply)'], ['xl', 'Extra load (XL)']
  ];
  var params = new URL(location.href).searchParams;
  var requestedSeason = params.get('tnt_season');
  var fromQuery = window.TntSearchQuery.seasonFromQuery(params.get('q') || '');
  var filters = { season: seasons.concat(['winter']).includes(requestedSeason) ? requestedSeason : requestedSeason === 'all' ? null : fromQuery };
  toggles.forEach(function (entry) { filters[entry[0]] = params.get('tnt_' + entry[0]) === '1'; });
  var names = { NL: 'Newfoundland', NS: 'Nova Scotia', NB: 'New Brunswick', PE: 'Prince Edward Island',
    QC: 'Quebec', ON: 'Ontario', MB: 'Manitoba', SK: 'Saskatchewan', AB: 'Alberta', BC: 'British Columbia' };
  function grid() {
    var wrapper = document.getElementById('product-grid');
    return wrapper && (wrapper.matches('ul,ol') ? wrapper : wrapper.querySelector('ul.product-grid,ol.product-grid'));
  }
  function current(state) { return active === state && state.grid.isConnected; }
  function queryURL() {
    var url = new URL(location.href);
    url.searchParams.delete('page'); url.searchParams.delete('province');
    Array.from(url.searchParams.keys()).forEach(function (key) { if (key.indexOf('tnt_') === 0) url.searchParams.delete(key); });
    var q = url.searchParams.get('q') || '';
    if (!url.searchParams.has('filter.p.vendor')) {
      // Use actual Shopify facet values, not an invented brand list. Cache the
      // inference so facet DOM replacement cannot start/stop the same scan.
      if (!vendorCache.has(q)) {
        var vendors = Array.from(document.querySelectorAll('input[name="filter.p.vendor"]')).map(function (input) { return input.value; });
        if (vendors.length) vendorCache.set(q, window.TntSearchQuery.vendorForQuery(q, vendors));
      }
      var vendor = vendorCache.get(q);
      if (vendor) url.searchParams.set('filter.p.vendor', vendor);
    }
    var textCandidate = !url.searchParams.has('filter.p.vendor') && window.TntSearchQuery.candidateText(q);
    q = q.replace(/\(\s*(?:tag:)?["']?province:[a-z]+["']?\s+OR\s+(?:tag:)?["']?province:ALL["']?\s*\)/gi, ' ');
    q = q.replace(/\b(?:tag:)?["']?province:[a-z]+["']?/gi, ' ');
    if (window.TntSearchQuery.hasSize(q)) q = window.TntSearchQuery.stripSeasonText(q);
    q = q.replace(/\b(LT|P|ST)?(\d{3})\/(\d{2,3})R(\d{2})(?![.\d])/gi, function (_, prefix, width, aspect, rim) {
      return 'tag:' + width + aspect + rim + (prefix && prefix.toUpperCase() === 'LT' ? ' tag:LT' : '');
    });
    q = q.replace(/(^|[\s(])(\d{6,8})(?=$|[\s)])/g, '$1tag:$2');
    url.searchParams.set('q', textCandidate || q.trim()); url.searchParams.set('type', 'product');
    // Relevance ties are not a stable traversal of Shopify's fuzzy candidates.
    // Use the store's existing default price order explicitly on every page.
    if (!url.searchParams.get('sort_by')) url.searchParams.set('sort_by', 'price-ascending');
    var codes = window.TntSearchQuery.numericSizeCodes(q);
    var advanced = q.replace(/\btag:\s*\d{6,8}\b/gi, '');
    if (codes.length === 1 && !/[a-z_]+:/i.test(advanced) && !/\b(?:OR|NOT)\b/i.test(advanced)) {
      // Native tag routing bounds metadata to the numeric size on the server.
      // The customer's visible page stays /search.
      url.pathname = '/collections/all/' + codes[0];
      url.searchParams.set('tnt_size_data', '2');
      ['q', 'type', 'options', 'options[prefix]', 'options[unavailable_products]'].forEach(function (key) { url.searchParams.delete(key); });
      if (url.searchParams.get('sort_by') === 'relevance') url.searchParams.set('sort_by', 'best-selling');
    } else if (url.searchParams.getAll('filter.p.vendor').length === 1 &&
        !/[a-z_]+:/i.test(q) && !/\b(?:OR|NOT)\b/i.test(q)) {
      // Brand searches must not traverse the inconsistent search index.
      // Native vendor facets bound the candidate set; model/season stays local.
      url.pathname = '/collections/vendors';
      var selectedVendor = url.searchParams.get('filter.p.vendor');
      ['type', 'options', 'options[prefix]', 'options[unavailable_products]'].forEach(function (key) { url.searchParams.delete(key); });
      url.searchParams.set('q', selectedVendor);
      url.searchParams.delete('filter.p.vendor');
      if (url.searchParams.get('sort_by') === 'relevance') url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('tnt_vendor_data', '1');
    }
    url.searchParams.set('view', url.pathname === '/collections/vendors' ? 'tnt-vendor-results'
      : url.pathname.indexOf('/collections/all/') === 0 ? 'tnt-size-results' : 'tnt-results');
    return url;
  }
  function syncLinks() {
    var province = window.TntProvinceStock && window.TntProvinceStock.selectedProvince();
    if (!province) return;
    var url = new URL(location.href);
    url.searchParams.set('province', province); url.searchParams.set('type', 'product');
    if (!url.searchParams.get('sort_by')) {
      url.searchParams.set('sort_by', 'price-ascending');
      document.querySelectorAll('#SortBy, #SortBy-mobile').forEach(function (select) {
        select.value = 'price-ascending';
      });
    }
    if (url.href !== location.href) history.replaceState(history.state, '', url.href);
    var values = { province: province, type: 'product', tnt_season: filters.season || 'all' };
    toggles.forEach(function (entry) { if (filters[entry[0]]) values['tnt_' + entry[0]] = '1'; });
    document.querySelectorAll('facet-filters-form form, #FacetSortForm, #FacetSortDrawerForm').forEach(function (form) {
      form.querySelectorAll('[data-tnt-search-param]').forEach(function (input) { if (!(input.name in values)) input.remove(); });
      Object.keys(values).forEach(function (name) {
        var input = form.querySelector('input[name="' + name + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.dataset.tntSearchParam = 'true'; form.appendChild(input); }
        if (input.value !== values[name]) input.value = values[name];
      });
    });
  }
  function saveFilters() {
    var url = new URL(location.href);
    url.searchParams.set('tnt_season', filters.season || 'all');
    toggles.forEach(function (entry) {
      if (filters[entry[0]]) url.searchParams.set('tnt_' + entry[0], '1');
      else url.searchParams.delete('tnt_' + entry[0]);
    });
    history.replaceState(history.state, '', url.href);
    syncLinks();
  }
  function sortTo(value) {
    syncLinks();
    var select = document.querySelector('#SortBy, #SortBy-mobile');
    if (select) { select.value = value; select.dispatchEvent(new Event('input', { bubbles: true })); }
    else { var url = new URL(location.href); url.searchParams.set('sort_by', value); location.assign(url.href); }
  }
  function mountChips() {
    if (controls && controls.isConnected) return;
    var anchor = document.querySelector('.template-search__search');
    if (!anchor) return;
    controls = document.createElement('div'); controls.id = 'tnt-search-chips';
    controls.className = 'page-width'; controls.setAttribute('aria-label', 'Quick product filters');
    var style = document.createElement('style');
    style.textContent = '#tnt-search-chips{margin:2rem auto;text-align:center}#tnt-search-chips .tnt-chip-row{display:flex;flex-wrap:wrap;justify-content:center;gap:.6rem;margin:.9rem 0}#tnt-search-chips button{padding:.65rem 1.1rem;border:1px solid #80938f;border-radius:999px;background:#f1f5f4;color:#17332f;font:inherit;cursor:pointer}#tnt-search-chips button[aria-pressed="true"]{background:#154e49;color:white;border-color:#154e49;font-weight:700}#tnt-search-chips button:focus-visible{outline:3px solid #1670c5;outline-offset:3px}#tnt-search-chips .tnt-season-row button{background:#e4edf1}#tnt-search-chips .tnt-season-row button[aria-pressed="true"]{background:#184563;color:white}';
    style.textContent += '.tnt-destination-pagination [hidden],#tnt-sort-control[hidden],#tnt-size-integrity-loading[hidden]{display:none!important}';
    controls.appendChild(style);
    function row(title, choices, kind) {
      var group = document.createElement('div'); group.className = 'tnt-chip-row' + (kind === 'season' ? ' tnt-season-row' : '');
      group.setAttribute('role', 'group'); group.setAttribute('aria-label', title);
      choices.forEach(function (entry) {
        var button = document.createElement('button'); button.type = 'button'; button.textContent = entry[1];
        button.dataset.tntChip = entry[0]; button.dataset.tntChipKind = kind; button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', function () {
          if (kind === 'season') filters.season = filters.season === entry[0] ? null : entry[0];
          else filters[entry[0]] = !filters[entry[0]];
          changed();
        });
        group.appendChild(button);
      }); controls.appendChild(group);
    }
    row('Tire season', seasons.map(function (season, i) { return [season, labels[i]]; }), 'season');
    row('Filter results', toggles, 'toggle');
    var clear = document.createElement('button'); clear.type = 'button'; clear.textContent = 'Clear filters'; clear.dataset.tntClear = 'true';
    clear.addEventListener('click', function () {
      filters.season = null; toggles.forEach(function (entry) { filters[entry[0]] = false; }); changed();
    });
    controls.appendChild(clear); anchor.after(controls);
    ['tnt-quick-filters', 'tnt-season-filters', 'tnt-sort-control', 'tnt-size-integrity-loading'].forEach(function (id) {
      var legacy = document.getElementById(id);
      if (legacy) { legacy.hidden = true; legacy.style.display = 'none'; }
    });
    var price = document.createElement('button'); price.type = 'button'; price.textContent = 'Price: low to high'; price.dataset.tntPriceSort = 'true';
    price.addEventListener('click', function () {
      var value = new URL(location.href).searchParams.get('sort_by') === 'price-ascending' ? 'relevance' : 'price-ascending';
      sortTo(value);
    });
    controls.appendChild(price);
    updateChips();
  }
  function updateChips() {
    if (!controls) return;
    controls.querySelectorAll('[data-tnt-chip]').forEach(function (button) {
      var on = button.dataset.tntChipKind === 'season' ? filters.season === button.dataset.tntChip : !!filters[button.dataset.tntChip];
      button.setAttribute('aria-pressed', String(on));
    });
    controls.querySelector('[data-tnt-clear]').hidden = !filters.season && !toggles.some(function (entry) { return filters[entry[0]]; }) && new URL(location.href).searchParams.get('sort_by') !== 'price-ascending';
    controls.querySelector('[data-tnt-price-sort]').setAttribute('aria-pressed', String(new URL(location.href).searchParams.get('sort_by') === 'price-ascending'));
  }
  function changed() {
    saveFilters(); updateChips();
    if (active) { active.target = 24; active.renderKey = null; render(active); }
  }
  function matchesQuery(record) {
    // Sold-out alternatives box: honour Shopify price/in-stock filter params, which the
    // numeric-size tag route cannot apply on the server.
    var tntFilterParams = new URL(location.href).searchParams;
    var tntMin = parseFloat(tntFilterParams.get('filter.v.price.gte')), tntMax = parseFloat(tntFilterParams.get('filter.v.price.lte'));
    if (isFinite(tntMin) && record.price < Math.round(tntMin * 100)) return false;
    if (isFinite(tntMax) && record.price > Math.round(tntMax * 100)) return false;
    if (tntFilterParams.get('filter.v.availability') === '1' && record.available === false) return false;
    if (!window.TntSearchQuery.matchesSizeTags(record, new URL(location.href).searchParams.get('q') || '')) return false;
    if (!window.TntSearchQuery.textMatches(record, new URL(location.href).searchParams.get('q') || '')) return false;
    if (window.TntSearchIntegrity && !window.TntSearchIntegrity.matchesItem(record,
      window.TntSearchIntegrity.parseConstraint(new URL(location.href).searchParams.get('q') || ''))) return false;
    return true;
  }
  function matches(record) {
    if (!matchesQuery(record)) return false;
    var card = record.node.querySelector('.card-wrapper'), tags = record.tags.map(function (tag) { return String(tag).toLowerCase(); });
    var title = record.title.toUpperCase(), season = window.TntTirePicks.season(record.type, tags);
    if (!window.TntSearchQuery.seasonMatchesRecord(record, filters.season)) return false;
    if (filters.stock && Number(card.dataset.tntStockQty) < 4) return false;
    if (filters.nl && !['nl', 'our_stock'].includes(card.dataset.tntStockBucket)) return false;
    if (filters.direct && !tags.includes('our stock')) return false;
    if (filters.lt && !tags.includes('lt') && !/^LT\d/.test(title)) return false;
    if (filters.xl && !tags.includes('xl') && !/\bXL\b/.test(title)) return false;
    return ['c', 'd', 'e', 'f'].every(function (range) {
      return !filters['lr' + range] || tags.includes('lr' + range) ||
        new RegExp('\\bLR' + range.toUpperCase() + '\\b|\\bLOAD RANGE ' + range.toUpperCase() + '\\b|\\b' + ({ c: 6, d: 8, e: 10, f: 12 }[range]) + '[ -]?PLY\\b').test(title + ' ' + tags.join(' ').toUpperCase());
    });
  }
  function renderPicks(state, matching) {
    var row = document.getElementById('tnt-verified-picks');
    if (!row) return;
    var constraint = window.TntSearchIntegrity &&
      window.TntSearchIntegrity.parseConstraint(new URL(location.href).searchParams.get('q') || '');
    var exact = constraint && constraint.constrained && !constraint.invalid;
    var eligible = matching.filter(function (record) {
      return exact && window.TntSearchIntegrity.matchesItem(record, constraint);
    }).map(function (record) {
      var card = record.node.querySelector('.card-wrapper');
      return Object.assign({}, record, { stock: {
        known: card.dataset.tntStockKnown === 'true',
        state: card.dataset.tntDestinationState,
        exempt: card.dataset.tntDestinationExempt === 'true',
        preorder: card.dataset.tntStockPreorder === 'true' || record.tags.includes('preorder'),
        available: Number(card.dataset.tntStockQty),
        mountPearlAvailable: card.dataset.tntMountPearlAvailable === '' ? null : Number(card.dataset.tntMountPearlAvailable),
        bucket: card.dataset.tntStockBucket
      } });
    });
    var today = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/St_Johns', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());
    var ready = state.complete && !state.error && !state.limited;
    var mountPearlVerified = eligible.length === 0 || eligible.every(function (record) {
      return Number.isSafeInteger(record.stock.mountPearlAvailable);
    });
    var picks = ready ? window.TntTirePicks.choose(eligible, {
      province: state.province, today: today, rules: state.rules || { programs: [], premiumBrands: [] }
    }) : {};
    var signature = JSON.stringify([state.province, filters, ready, state.error, state.limited, !!state.rules, state.rulesError, exact, mountPearlVerified,
      ['premium', 'value', 'free'].map(function (tier) { return picks[tier] && [picks[tier].handle, picks[tier].price]; })]);
    if (row.dataset.renderKey === signature) return;
    row.dataset.renderKey = signature;
    var headings = { premium: 'Premium Pick', value: 'Best Value', free: 'Free Newfoundland Shipping Pick' };
    var subtitles = { premium: 'Lowest-priced premium set after listed eligible rebates',
      value: 'Lowest-priced matching set before rebates',
      free: 'Eligible set stocked at the Mount Pearl warehouse' };
    function add(parent, tag, text, className) {
      var el = document.createElement(tag); el.textContent = text;
      if (className) el.className = className;
      parent.appendChild(el); return el;
    }
    ['premium', 'value', 'free'].forEach(function (tier) {
      var box = row.querySelector('[data-tier="' + tier + '"]');
      box.replaceChildren();
      add(box, 'h2', headings[tier], 'tnt-spotlight-badge');
      add(box, 'p', subtitles[tier], 'tnt-spotlight-subtitle');
      var unavailable = !exact ? 'Choose an exact tire size to see this pick.'
        : state.error ? 'Recommendations could not be verified. Retry loading results.'
        : state.limited ? 'Narrow the search with a tire size or brand to verify this pick.'
        : !ready ? 'Checking all matching products and live stock…'
        : tier === 'free' && state.province !== 'NL' ? 'This pick is for Newfoundland island delivery. Choose Newfoundland to check availability.'
        : tier === 'free' && !mountPearlVerified ? 'Exact Mount Pearl stock verification is not available yet. Please try again later.'
        : tier === 'premium' && !state.rules ? 'Premium rebates could not be verified. Try reloading this page.'
        : !picks[tier] ? tier === 'free' ? 'No qualifying Mount Pearl set is currently available for this size and season.'
          : 'No qualifying set is currently available for this size and season.'
        : null;
      if (unavailable) { add(box, 'p', unavailable); return; }
      var item = picks[tier];
      if (item.image) {
        var wrap = document.createElement('div'); wrap.className = 'tnt-spotlight-image-wrap';
        var img = document.createElement('img'); img.src = item.image; img.alt = item.title;
        img.loading = 'lazy'; img.width = 300; img.height = 300; wrap.appendChild(img); box.appendChild(wrap);
      }
      add(box, 'h3', item.title, 'tnt-spotlight-title');
      var money = function (cents) { return new Intl.NumberFormat('en-CA', {
        style: 'currency', currency: item.currency || 'CAD'
      }).format(cents / 100); };
      add(box, 'p', money(item.price) + ' CAD each', 'tnt-spotlight-price');
      add(box, 'p', 'Set of 4: ' + money(item.price * 4) + ' before tax and fees', 'tnt-spotlight-set4');
      var amount = state.rules ? window.TntTirePicks.rebate(item, state.rules, today) : 0;
      if (amount > 0) {
        add(box, 'p', 'Estimated after rebate: ' + money(item.price * 4 - amount) + ' for 4');
        var terms = add(box, 'a', money(amount) + ' manufacturer rebate. Eligible purchase and installation terms apply; not deducted at checkout.');
        terms.href = '/pages/rebates'; terms.style.cssText = 'font-size:1.2rem;line-height:1.5;margin-bottom:1rem';
      } else if (tier === 'premium') {
        add(box, 'p', 'No listed model-specific rebate deducted.');
      }
      if (tier === 'free') add(box, 'p', 'Free shipping on 4 to eligible Newfoundland island addresses. Checkout confirms your address.');
      var link = add(box, 'a', 'View tire', 'tnt-spotlight-link');
      var url = new URL('/products/' + encodeURIComponent(item.handle), location.origin);
      if (item.variantId) url.searchParams.set('variant', item.variantId);
      url.searchParams.set('province', state.province); link.href = url.href;
      box.dataset.handle = item.handle;
    });
  }
  function render(state) {
    if (!current(state)) return;
    var matching = state.pool.filter(matches), visible = matching.slice(0, state.target);
    renderPicks(state, matching);
    var signature = visible.map(function (record) { return record.handle; }).join('|');
    if (state.renderKey !== signature) {
      state.grid.replaceChildren();
      visible.forEach(function (record, index) {
        var node = record.node.cloneNode(true);
        if (index < 4) node.querySelectorAll('img').forEach(function (image) {
          image.loading = 'eager'; image.decoding = 'async';
        });
        state.grid.appendChild(node);
      });
      state.renderKey = signature;
    }
    var area = names[state.province] || state.province;
    state.count.textContent = state.error ? 'Full result count could not be verified. Retry loading results.'
      : state.limited ? 'Found ' + matching.length + ' verified matches in a limited search' + (matching.length > visible.length ? ' · ' + visible.length + ' shown' : '') + '. Add a tire size or brand to finish checking all results.'
      : !state.complete ? (visible.length ? 'Showing ' + visible.length + ' verified product' + (visible.length === 1 ? '' : 's') + '. Checking remaining matches for ' + area + '…' : 'Counting matching products for ' + area + '…')
      : matching.length + ' product' + (matching.length === 1 ? '' : 's') + ' available in ' + area + (matching.length > visible.length ? ' · ' + visible.length + ' shown' : '');
    state.button.textContent = state.error ? 'Retry loading results' : 'Load more';
    state.button.hidden = !state.error && (state.complete ? matching.length <= state.target : matching.length <= state.target);
    state.button.disabled = false;
    state.grid.setAttribute('aria-busy', String(!state.complete && !visible.length && !state.error && !state.limited));
    state.grid.dataset.tntSearchState = state.error ? 'error' : state.limited ? 'limited' : state.complete ? 'ready' : 'loading';
    state.grid.dataset.tntSearchError = state.errorReason || '';
    if (state.complete && !state.error) {
      var query = new URL(location.href).searchParams.get('q') || '';
      document.title = 'Search: ' + matching.length + ' result' + (matching.length === 1 ? '' : 's') +
        ' for "' + query + '"' + (titleSuffix ? ' \u2013 ' + titleSuffix : '');
    }
  }
  async function readPage(state, url) {
    if (!current(state)) return null;
    if (cache.has(url)) return cache.get(url);
    var controller = new AbortController(); state.abort = controller;
    var deadline = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response;
      for (var attempt = 0; attempt < 2; attempt++) {
        response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (response.status !== 429 || attempt === 1) break;
        var retryAfter = response.headers && response.headers.get('Retry-After');
        var retryMs = retryAfter ? Number(retryAfter) * 1000 : 1500;
        if (!Number.isFinite(retryMs)) retryMs = Date.parse(retryAfter) - Date.now();
        if (!Number.isFinite(retryMs)) retryMs = 1500;
        await new Promise(function (resolve) { setTimeout(resolve, Math.max(500, Math.min(5000, retryMs))); });
        if (!current(state)) return null;
      }
      if (!response.ok) throw new Error('Search data could not be loaded.');
      var data = await response.json();
      if (!Number.isSafeInteger(data.total) || data.total < 0 || !Array.isArray(data.items)) throw new Error('Invalid search result data.');
      var scopePath = new URL(state.initialUrl).pathname;
      if (new URL(state.initialUrl).searchParams.get('view') === 'tnt-vendor-results') {
        var expectedVendor = new URL(state.initialUrl).searchParams.get('q');
        if (data.vendorScope !== expectedVendor || data.items.some(function (item) {
          return String(item.vendor || '').toLowerCase() !== expectedVendor.toLowerCase();
        })) throw new Error('The brand lookup was not preserved.');
      }
      if (/^\/collections\/all\/\d{6,8}$/.test(scopePath) && data.tagMissing === true &&
          data.sizeTag === null && data.total === 0 && data.items.length === 0 && !data.next) {
        data.sizeTag = scopePath.split('/').pop();
      }
      if (/^\/collections\/all\/\d{6,8}$/.test(scopePath) && data.sizeTag !== scopePath.split('/').pop()) {
        throw new Error('The numeric size tag lookup was not preserved.');
      }
      if (data.next) {
        var next = new URL(data.next, url);
        if (next.origin !== location.origin || next.pathname !== scopePath) throw new Error('Unexpected pagination link.');
        next.searchParams.set('view', new URL(state.initialUrl).searchParams.get('view') || 'tnt-results'); next.searchParams.set('type', 'product');
        if (/^\/collections\/all\/\d{6,8}$/.test(scopePath)) next.searchParams.set('tnt_size_data', '2');
        if (new URL(state.initialUrl).searchParams.get('view') === 'tnt-vendor-results') {
          var vendorScope = new URL(state.initialUrl).searchParams.get('q');
          if (next.searchParams.get('q') !== vendorScope) throw new Error('The brand pagination filter was not preserved.');
          next.searchParams.set('tnt_vendor_data', '1');
        }
        data.next = next.href;
      }
      if (!current(state)) return null;
      if (cache.size >= 80) cache.delete(cache.keys().next().value);
      cache.set(url, data); return data;
    } finally { clearTimeout(deadline); }
  }
  async function scan(state) {
    if (state.busy || !current(state)) return;
    if (state.error) {
      // A changing catalog or failed stock batch invalidates the entire scan.
      // Retry from fresh page one, not a cached/previously visited failed page.
      cache.clear();
      window.TntTirePicks.restart(state);
      state.limited = false;
    }
    state.busy = true; state.error = false; state.errorReason = ''; render(state);
    try {
      var queued = null;
      while (current(state) && state.next) {
        var url = state.next;
        if (state.visited.has(url)) throw new Error('Pagination repeated a page.');
        var outcome = queued && queued.url === url ? await queued.promise : { data: await readPage(state, url) };
        queued = null;
        if (outcome.error) throw outcome.error;
        var data = outcome.data;
        if (!data || !current(state)) return;
        if (state.expected !== null && state.expected !== data.total) {
          var changedCatalog = new Error('Catalog changed during pagination.');
          changedCatalog.catalogChanged = true; throw changedCatalog;
        }
        // One page ahead only: overlap Shopify metadata with the existing
        // stock check. Never publish cards or final recommendations early.
        if (data.next) queued = {
          url: data.next,
          promise: readPage(state, data.next).then(function (page) { return { data: page }; },
            function (error) { return { error: error }; })
        };
        var records = data.items.map(function (item) {
          if (!item.handle || !Array.isArray(item.tags) || typeof item.html !== 'string' || !Number.isSafeInteger(item.price) || item.price < 0) throw new Error('Invalid product metadata.');
          state.candidates.add(item.handle);
          // An irrelevant supplier/product must not hold up a matching tire.
          // Preserve candidate completeness while only verifying matching stock.
          if (!window.TntSearchQuery.textMatches(item, new URL(location.href).searchParams.get('q') || '')) return null;
          var node = document.createElement('li'); node.className = 'grid__item'; node.innerHTML = item.html;
          node.dataset.tntPrice = String(item.price);
          if (!node.querySelector('.card-wrapper [data-tnt-destination-variant]')) throw new Error('Product availability marker missing.');
          var tags = item.tags.map(function (tag) { return String(tag).toLowerCase(); });
          var record = Object.assign({}, item, { node: node, tire: !tags.includes('wheel') &&
            (tags.includes('tire') || !!window.TntTirePicks.season(item.type, tags)) });
          return matchesQuery(record) ? record : null;
        }).filter(Boolean);
        var stockDeadline;
        try {
          if (records.length) await Promise.race([
            window.TntProvinceStock.prepareCards(records.map(function (record) { return record.node; })),
            new Promise(function (_, reject) { stockDeadline = setTimeout(function () { reject(new Error('Availability check timed out.')); }, 35000); })
          ]);
        } finally { clearTimeout(stockDeadline); }
        if (!current(state)) return;
        if (records.some(function (record) {
          var data = record.node.querySelector('.card-wrapper').dataset;
          return !['ready', 'unavailable'].includes(data.tntDestinationState) || !window.TntTirePicks.stockVerified(data);
        })) {
          throw new Error('Some availability checks failed.');
        }
        records.forEach(function (record) {
          var card = record.node.querySelector('.card-wrapper');
          if (card.dataset.tntDestinationState === 'ready' && card.dataset.tntDestinationExempt !== 'true' && !state.seen.has(record.handle)) {
            state.seen.add(record.handle); state.pool.push(record);
          }
        });
        state.visited.add(url); state.next = data.next; state.expected = data.total;
        render(state);
      }
      if (current(state)) {
        // A maximum-size candidate response is not a complete catalog.
        // Stop honestly instead of retrying the same capped pages.
        if (new URL(state.initialUrl).searchParams.get('view') !== 'tnt-vendor-results' && state.expected >= 1000 && state.visited.size >= 20) {
          state.limited = true;
        } else if (state.candidates.size !== state.expected) {
          var incomplete = new Error('The complete search result set was not available.');
          incomplete.catalogChanged = true; throw incomplete;
        }
        state.complete = !state.limited;
      }
    } catch (error) {
      if (current(state)) {
        if (state.abort) state.abort.abort();
        state.error = true;
        state.errorReason = error.message || 'Search request failed.';
        if (error.catalogChanged && state.catalogRetries < 1) {
          state.catalogRetries++;
          setTimeout(function () { if (current(state) && state.error && !state.busy) scan(state); }, 2500);
        }
      }
    }
    finally { if (current(state)) { state.busy = false; render(state); } }
  }
  function start() {
    var core = window.TntProvinceStock, list = grid();
    if (!core) return;
    mountChips();
    if (!core.selectedProvince()) return;
    if (!list) {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return;
      list = document.createElement('ul'); list.id = 'product-grid'; list.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop'; list.setAttribute('role', 'list');
      container.replaceChildren(list);
    }
    syncLinks(); updateChips();
    var url = queryURL().href, province = core.selectedProvince();
    if (active && active.grid === list && active.key === url && active.province === province) return;
    if (active && active.abort) active.abort.abort();
    if (active && active.controls.isConnected) active.controls.remove();
    var count = document.getElementById('tnt-destination-count');
    if (!count) { count = document.createElement('p'); count.id = 'tnt-destination-count'; count.setAttribute('role', 'status'); list.before(count); }
    var pagination = document.createElement('div'); pagination.className = 'tnt-destination-pagination';
    var button = document.createElement('button'); button.type = 'button'; button.className = 'button button--secondary'; pagination.appendChild(button); list.after(pagination);
    var state = { key: url, province: province, grid: list, count: count, controls: pagination, button: button,
      initialUrl: url, next: url, expected: null, target: 24, pool: [], candidates: new Set(), seen: new Set(), visited: new Set(), complete: false, error: false, limited: false, busy: false, renderKey: null,
      rules: null, rulesError: false, catalogRetries: 0 };
    active = state;
    document.querySelectorAll('#ProductGridContainer .pagination-wrapper').forEach(function (node) { node.hidden = true; });
    button.addEventListener('click', function () { if (state.error) scan(state); else { state.target += 24; render(state); } });
    var row = document.getElementById('tnt-verified-picks');
    if (row) fetch(row.dataset.tntRebateRules, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('Rebate configuration unavailable'); return res.json(); })
      .then(function (rules) {
        if (!Array.isArray(rules.programs) || !Array.isArray(rules.premiumBrands) || rules.programs.some(function (p) {
          return typeof p.brand !== 'string' || !Number.isSafeInteger(p.cents) || p.cents < 0 ||
            !/^\d{4}-\d{2}-\d{2}$/.test(p.start) || !/^\d{4}-\d{2}-\d{2}$/.test(p.end) ||
            !(p.models === '*' || Array.isArray(p.models));
        })) throw new Error('Invalid rebate configuration');
        state.rules = rules; if (current(state)) render(state);
      }).catch(function () { state.rulesError = true; if (current(state)) render(state); });
    scan(state);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(start, 0); }
  window.TntSearchResults = { owns: function (node) { return !!active && !!node && (node === active.grid || node.contains(active.grid)); } };
  window.TntDestinationResults = window.TntSearchResults;
  document.addEventListener('tnt:provinceChanged', schedule);
  window.addEventListener('popstate', function () {
    var p = new URL(location.href).searchParams;
    var value = p.get('tnt_season');
    filters.season = seasons.concat(['winter']).includes(value) ? value : value === 'all' ? null : window.TntSearchQuery.seasonFromQuery(p.get('q') || '');
    toggles.forEach(function (entry) { filters[entry[0]] = p.get('tnt_' + entry[0]) === '1'; });
    updateChips(); if (active) { active.renderKey = null; render(active); } schedule();
  });
  new MutationObserver(function () {
    if (!document) return;
    if (!active || active.grid !== grid() || active.key !== queryURL().href) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
